import styled from '@emotion/styled';

export const FormContainer = styled.div`
    width: 100%;
    padding: 2rem;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const FormTitle = styled.h2`
    margin-bottom: 2rem;
    color: #333;
`;

export const FormGroup = styled.div`
    margin-bottom: 1.5rem;
`;

export const Label = styled.label`
    display: block;
    margin-bottom: 0.5rem;
`;

export const Input = styled.input`
    width: 100%;
    padding: 0.75rem;
    border: 1px solid #ddd;
    border-radius: 4px;

    &:focus {
        outline: none;
        border-color: #646cff;
    }
`;

export const ErrorText = styled.span`
    color: #dc3545;
    margin-top: 0.25rem;
    display: block;
`;

export const LoadingMessage = styled.div`
    text-align: center;
    padding: 2rem;
`;
